import type { EnterpriseUpsellFeature, EnterpriseUpsellMetric } from './EnterpriseUpsell';

// Canonical Enterprise-plan feature list + decorative metrics rendered by every
// PRO-plan upsell/FOMO surface (Analytics, Playlists, Certification Insights).
// These are identical across variants in the PRO-plan Figma; only the
// eyebrow/headline/description change per surface, so the shared content lives
// here to avoid duplicating (and drifting) the same copy across each consumer.
export const ENTERPRISE_UPSELL_FEATURES: EnterpriseUpsellFeature[] = [
  { id: 'playlists', label: 'Curated playlists with deadlines' },
  { id: 'certification-insights', label: 'Certification insights across your organization' },
  { id: 'onboarding', label: 'Custom onboarding & direct support' },
  { id: 'analytics', label: 'Analytics dashboards with learner data' },
  { id: 'reports', label: 'Scheduling & exporting custom reports' },
];

export const ENTERPRISE_UPSELL_METRICS: EnterpriseUpsellMetric[] = [
  { id: 'certifications-earned', quantity: 230, label: 'Certifications earned' },
  { id: 'video-watch-time', quantity: '132h 32m', label: 'Video watch time', sparkline: true },
];

export interface EnterpriseUpsellCopy {
  eyebrow: string;
  /** Rendered highlighted inside the "Unlock <highlight> with Enterprise" headline. */
  headlineHighlight: string;
  description?: string;
}

export const PLAYLISTS_UPSELL_COPY: EnterpriseUpsellCopy = {
  eyebrow: 'Playlists · Enterprise feature',
  headlineHighlight: 'Playlists',
  description:
    'Build guided training collections with deadlines and assign them to users, teams, and accounts.',
};

export const ANALYTICS_UPSELL_COPY: EnterpriseUpsellCopy = {
  eyebrow: 'Analytics · Enterprise feature',
  headlineHighlight: 'Analytics',
  description:
    "Track your team's progress, identify skill gaps, and see the ROI of training with analytics and learner management features.",
};

// No description: this surface's Figma frame is 333px tall vs the
// Playlists/Analytics 401px — it goes straight from headline to CTAs.
export const CERTIFICATION_INSIGHTS_UPSELL_COPY: EnterpriseUpsellCopy = {
  eyebrow: 'Certification Insights · Enterprise feature',
  headlineHighlight: 'Certification Insights',
};
